var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropacityplush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 40,
    viewBox: "0 0 212 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2622 38.4785C16.7519 39.2784 21.04 36.2871 21.8398 31.7973L22.0311 30.7236L13.9017 29.2754L12.2622 38.4785Z",
    fill: "url(#paint0_linear_879_4862)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.894531 22.3625C0.894531 18.7486 3.89785 15.5566 7.51179 15.5566H17.5869L16.6245 22.3625H0.894531Z",
    fill: "url(#paint1_linear_879_4862)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_879_4862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 37,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.899414 22.3558C0.899414 18.6032 3.94154 15.561 7.69418 15.561H18.156L17.1791 22.3558H0.899414Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9175 15.5631C36.9175 19.3158 33.8754 22.3579 30.1227 22.3579H19.6609L20.6378 15.5631H36.9175Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5574 2.56461C22.2547 3.20688 24.7313 6.72477 24.089 10.4221L22.2985 20.7295L15.7712 18.604L18.5574 2.56461Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_879_4862)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.151367,
    y: -2.70654,
    width: 44.2328,
    height: 43.1797,
    fill: "url(#paint2_linear_879_4862)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3321 11.0952C43.0048 13.0917 42.2356 14.9246 41.0246 16.5938C39.8136 18.2302 38.1608 19.5558 36.0661 20.5704C34.0042 21.585 31.5659 22.0923 28.7511 22.0923H23.5472L21.7508 32.3866L13.4414 31.8673L19.0305 0H32.6296C36.2298 0 38.9463 0.801868 40.7792 2.4056C42.612 3.97661 43.5284 6.12038 43.5284 8.83692C43.5284 9.65515 43.463 10.4079 43.3321 11.0952ZM29.2421 15.5137C32.3841 15.5137 34.2333 14.0409 34.7897 11.0952C34.8552 10.5716 34.8879 10.1952 34.8879 9.96608C34.8879 8.91874 34.5442 8.11687 33.8569 7.56047C33.2023 6.97135 32.1877 6.67678 30.8131 6.67678H26.2473L24.7254 15.5137H29.2421Z",
    fill: "url(#paint3_linear_879_4862)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6386 16.938C38.2093 20.1467 34.4855 22.1168 30.4661 22.32L23.4973 22.3467L24.7362 15.508H41.7212L40.6386 16.938Z",
    fill: "url(#paint4_linear_879_4862)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8306 33.0496L58.9406 10.8796H62.6006L62.2406 12.8296C62.9606 12.0896 63.8306 11.5196 64.8506 11.1196C65.8706 10.6996 66.9306 10.4896 68.0306 10.4896C70.1706 10.4896 71.8606 11.0896 73.1006 12.2896C74.3406 13.4896 74.9606 15.1196 74.9606 17.1796C74.9606 20.1396 73.9706 22.6696 71.9906 24.7696C70.0306 26.8496 67.6606 27.8896 64.8806 27.8896C62.9006 27.8896 61.3206 27.2396 60.1406 25.9396L59.4806 29.4946C59.4806 29.4946 59.2328 31.1422 58.5 31.875C56.9066 33.4684 54.8306 33.0496 54.8306 33.0496ZM66.9806 14.1496C65.3606 14.1496 63.9606 14.7596 62.7806 15.9796C61.6206 17.1796 61.0406 18.6096 61.0406 20.2696C61.0406 21.4296 61.4206 22.3796 62.1806 23.1196C62.9406 23.8596 63.9206 24.2296 65.1206 24.2296C66.6006 24.2296 67.9206 23.6196 69.0806 22.3996C70.2606 21.1596 70.8506 19.7696 70.8506 18.2296C70.8506 17.0496 70.4806 16.0796 69.7406 15.3196C69.0206 14.5396 68.1006 14.1496 66.9806 14.1496Z",
    fill: "url(#paint5_linear_879_4862)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6553 27.4996L78.7453 10.8796H82.4053L82.1053 12.4996C82.7653 11.7196 83.3853 11.1896 83.9653 10.9096C84.5453 10.6296 85.2953 10.4896 86.2153 10.4896H86.3953L85.6753 14.3296C83.2953 14.3296 81.8553 15.6396 81.3553 18.2596L79.6453 27.4996H75.6553Z",
    fill: "url(#paint6_linear_879_4862)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5146 10.4896C98.6746 10.4896 100.445 11.1596 101.825 12.4996C103.205 13.8396 103.895 15.5696 103.895 17.6896C103.895 20.3896 102.815 22.7696 100.655 24.8296C98.5146 26.8696 96.0246 27.8896 93.1846 27.8896C91.1446 27.8896 89.4246 27.2196 88.0246 25.8796C86.6246 24.5396 85.9246 22.8696 85.9246 20.8696C85.9246 18.1096 86.9846 15.6896 89.1046 13.6096C91.2246 11.5296 93.6946 10.4896 96.5146 10.4896ZM95.8846 14.1496C94.3446 14.1496 92.9846 14.7596 91.8046 15.9796C90.6246 17.1996 90.0346 18.6096 90.0346 20.2096C90.0346 21.3696 90.4046 22.3296 91.1446 23.0896C91.8846 23.8496 92.8346 24.2296 93.9946 24.2296C95.4946 24.2296 96.8346 23.6196 98.0146 22.3996C99.1946 21.1796 99.7846 19.7896 99.7846 18.2296C99.7846 17.0496 99.4146 16.0796 98.6746 15.3196C97.9546 14.5396 97.0246 14.1496 95.8846 14.1496Z",
    fill: "url(#paint7_linear_879_4862)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.179 10.8796L141.119 27.4996H137.459L137.849 25.3396C136.089 27.0396 134.089 27.8896 131.849 27.8896C129.769 27.8896 128.089 27.2696 126.809 26.0296C125.529 24.7896 124.889 23.1496 124.889 21.1096C124.889 18.1896 125.899 15.6896 127.919 13.6096C129.939 11.5296 132.389 10.4896 135.269 10.4896C137.569 10.4896 139.189 11.3596 140.129 13.0996L140.519 10.8796H144.179ZM134.909 14.1496C133.329 14.1496 131.949 14.7596 130.769 15.9796C129.589 17.1996 128.999 18.6296 128.999 20.2696C128.999 21.5096 129.359 22.4796 130.079 23.1796C130.799 23.8796 131.809 24.2296 133.109 24.2296C134.769 24.2296 136.159 23.6396 137.279 22.4596C138.399 21.2796 138.959 19.8196 138.959 18.0796C138.959 16.8596 138.599 15.8996 137.879 15.1996C137.159 14.4996 136.169 14.1496 134.909 14.1496Z",
    fill: "url(#paint8_linear_879_4862)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M156.993 22.0396H161.493C160.433 23.9196 159.093 25.3696 157.473 26.3896C155.873 27.3896 154.103 27.8896 152.163 27.8896C150.023 27.8896 148.253 27.2196 146.853 25.8796C145.453 24.5396 144.753 22.8496 144.753 20.8096C144.753 18.0896 145.813 15.6896 147.933 13.6096C150.053 11.5296 152.493 10.4896 155.253 10.4896C157.253 10.4896 158.883 10.9996 160.143 12.0196C161.403 13.0396 162.203 14.5096 162.543 16.4296H158.043C157.583 14.9096 156.453 14.1496 154.653 14.1496C153.073 14.1496 151.713 14.7396 150.573 15.9196C149.433 17.0996 148.863 18.5096 148.863 20.1496C148.863 21.3696 149.213 22.3596 149.913 23.1196C150.633 23.8596 151.593 24.2296 152.793 24.2296C154.513 24.2296 155.913 23.4996 156.993 22.0396Z",
    fill: "url(#paint9_linear_879_4862)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M163.253 27.4996L166.343 10.8796H170.333L167.243 27.4996H163.253ZM166.673 9.07959L167.363 5.32959H171.353L170.663 9.07959H166.673Z",
    fill: "url(#paint10_linear_879_4862)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171.06 27.4996L173.46 14.5096H171.51L172.2 10.8796H174.15L175.17 5.32959H179.16L178.14 10.8796H180.54L179.85 14.5096H177.45L175.05 27.4996H171.06Z",
    fill: "url(#paint11_linear_879_4862)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M180.024 33.0496L184.404 25.9396L181.104 10.8796H185.664L187.344 21.6496L193.374 10.8796H197.964L186 30.3114C186 30.3114 185.169 31.8021 184.125 32.5C182.732 33.4311 180.024 33.0496 180.024 33.0496Z",
    fill: "url(#paint12_linear_879_4862)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M103.581 33.0507L107.691 10.8807H111.351L110.991 12.8307C111.711 12.0907 112.581 11.5207 113.601 11.1207C114.621 10.7007 115.681 10.4907 116.781 10.4907C118.921 10.4907 120.611 11.0907 121.851 12.2907C123.091 13.4907 123.711 15.1207 123.711 17.1807C123.711 20.1407 122.721 22.6707 120.741 24.7707C118.781 26.8507 116.411 27.8907 113.631 27.8907C111.651 27.8907 110.071 27.2407 108.891 25.9407L108.231 29.4957C108.231 29.4957 107.983 31.1433 107.25 31.8761C105.657 33.4696 103.581 33.0507 103.581 33.0507ZM115.731 14.1507C114.111 14.1507 112.711 14.7607 111.531 15.9807C110.371 17.1807 109.791 18.6107 109.791 20.2707C109.791 21.4307 110.171 22.3807 110.931 23.1207C111.691 23.8607 112.671 24.2307 113.871 24.2307C115.351 24.2307 116.671 23.6207 117.831 22.4007C119.011 21.1607 119.601 19.7707 119.601 18.2307C119.601 17.0507 119.231 16.0807 118.491 15.3207C117.771 14.5407 116.851 14.1507 115.731 14.1507Z",
    fill: "url(#paint13_linear_879_4862)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_879_4862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 0,
    width: 14,
    height: 13
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M197.36 7.43602C197.36 6.02592 198.503 4.88281 199.914 4.88281H203.845L203.478 7.43602H197.36Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M210.419 4.88332C210.419 6.29342 209.276 7.43652 207.866 7.43652H203.935L204.302 4.88332H210.419Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M201.42 12.1391C202.809 12.3815 204.132 11.452 204.374 10.063L205.05 6.19039L202.472 6.11295L201.42 12.1391Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M203.522 2.76101e-05C204.911 0.241367 205.841 1.56325 205.6 2.95254L204.927 6.82566L202.475 6.02701L203.522 2.76101e-05Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_879_4862)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.36,
    width: 13.1496,
    height: 12.7387,
    fill: "url(#paint14_linear_879_4862)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_879_4862",
    x1: 15.999,
    y1: 41.001,
    x2: 18.999,
    y2: 22.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56568B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65238,
    stopColor: "#171725"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_879_4862",
    x1: 7.52162,
    y1: 18.8755,
    x2: 31.2178,
    y2: 15.7161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2064FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_879_4862",
    x1: 22.2678,
    y1: -2.70654,
    x2: 22.2678,
    y2: 40.4731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2064FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B37F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_879_4862",
    x1: 14,
    y1: 28,
    x2: 12,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56568B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_879_4862",
    x1: 10.6822,
    y1: 18.3512,
    x2: 32.7986,
    y2: 15.1917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2064FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171725"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_879_4862",
    x1: 114.916,
    y1: 8.75,
    x2: 115,
    y2: 21.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30304A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_879_4862",
    x1: 114.916,
    y1: 8.75,
    x2: 115,
    y2: 21.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30304A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_879_4862",
    x1: 114.916,
    y1: 8.75,
    x2: 115,
    y2: 21.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30304A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_879_4862",
    x1: 114.916,
    y1: 8.75,
    x2: 115,
    y2: 21.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30304A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_879_4862",
    x1: 114.916,
    y1: 8.75,
    x2: 115,
    y2: 21.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30304A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_879_4862",
    x1: 114.916,
    y1: 8.75,
    x2: 115,
    y2: 21.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30304A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_879_4862",
    x1: 114.916,
    y1: 8.75,
    x2: 115,
    y2: 21.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30304A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_879_4862",
    x1: 114.916,
    y1: 8.75,
    x2: 115,
    y2: 21.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30304A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_879_4862",
    x1: 114.916,
    y1: 8.75,
    x2: 115,
    y2: 21.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30304A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_879_4862",
    x1: 203.935,
    y1: 0,
    x2: 203.935,
    y2: 12.7387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#2E2E46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropacityplush);
export default __webpack_public_path__ + "static/media/propacityplush.1c3a880ba58087b12591cf494069b582.svg";
export { ForwardRef as ReactComponent };